/**
 * Erros de browser/DOM conhecidos como benignos — não devem derrubar a SPA nem poluir Sentry/DEV.
 */

const BENIGN_DOM_PATTERNS = [
  "removeChild",
  "insertBefore",
  "The node to be removed is not a child",
  "Failed to execute 'removeChild'",
  "Failed to execute 'insertBefore'",
  /** Chrome/Edge: Radix, charts e layout dinâmico — aviso do motor, não exceção real. */
  "ResizeObserver loop completed with undelivered notifications",
  "ResizeObserver loop",
];

const SENTRY_IGNORE_PATTERNS: RegExp[] = [
  /Invalid login credentials/i,
  /invalid\s+(login|credentials|password|email)/i,
  /invalid refresh token|refresh token not found/i,
  /session.*session_id.*does not exist|session_id claim in JWT does not exist/i,
  /useAuth is not defined|ArchivingModalForm is not defined/i,
  /E2E Sentry pipeline test|DEBUG-SENTRY-PIPELINE/i,
  /column\s+profiles_public\.sexo\s+does not exist/i,
  /column\s+ai_drafts\.\w+\s+does not exist/i,
  /client_contacts.*(schema cache|could not find|does not exist)/i,
  /(schema cache|could not find the table|relation).*client_contacts/i,
  /column\s+financial_monthly_entries\.contract_name\s+does not exist/i,
  /column\s+financial_assets\.net_team_value\s+does not exist/i,
  /column\s+financial_contracts\.coordinator_id\s+does not exist/i,
  /column\s+aasp_publicacoes\.advogados_citados\s+does not exist/i,
  /(schema cache|could not find the table|relation).*(commemorative_dates|document_versions|document_variables)/i,
  /(commemorative_dates|document_versions|document_variables).*(schema cache|could not find|does not exist)/i,
  /column\s+financial_transactions\.expense_accounting_type\s+does not exist/i,
  /Invalid key:/i,
  /Nenhum provedor de imagem disponível/i,
  /Square is not defined/i,
  /AbortError|BodyStreamBuffer was aborted|The operation was aborted/i,
  /api\.open-meteo\.com/i,
  /Acquiring an exclusive Navigator LockManager lock.*auth-token.*timed out/i,
  /Lock.*auth-token.*timed out waiting/i,
  /Sentry dropped data due to a quota|internal rate limit/i,
];

function messageFromUnknown(error: unknown): string {
  if (error instanceof Error) return error.message;
  if (error && typeof error === "object" && "message" in error) {
    return String((error as { message: unknown }).message);
  }
  return String(error ?? "");
}

/** Erro de janela/DOM/rede conhecido — não reportar como fatal nem ao Sentry. */
export function isBenignWindowError(error: unknown): boolean {
  if (error instanceof Error && error.name === "AbortError") return true;
  const msg = messageFromUnknown(error);
  if (BENIGN_DOM_PATTERNS.some((s) => msg.includes(s))) return true;
  return SENTRY_IGNORE_PATTERNS.some((re) => re.test(msg));
}
